import { render, staticRenderFns } from "./AppTabbar.vue?vue&type=template&id=5ad2421a&"
import script from "./AppTabbar.vue?vue&type=script&lang=js&"
export * from "./AppTabbar.vue?vue&type=script&lang=js&"
import style0 from "./AppTabbar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports